import MenuIcon from "@mui/icons-material/Menu";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import { styled } from "@mui/system";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import NavButton from "../utlity/NavButton";

const StyledAppBar = styled(AppBar)({
  backgroundColor: "#ffffff",
  borderBottom: "2px solid #1718FF",
  boxShadow: "none",
});

const theme = createTheme({
  palette: {
    text: {
      primary: "#1d1d1f",
    },
  },
});

function createPagesArray(tabs) {
  return (
    tabs &&
    tabs?.map((tab) => {
      return {
        link: tab,
        tag: capitalizeFirstLetter(tab),
      };
    })
  );
}

function capitalizeFirstLetter(string) {
  if (typeof string !== "string" || !string.length) {
    return string;
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const MAX_VISIBLE_LINKS = 5;

const Header = () => {
  const { data, loading, error } = useSelector((state) => state.tab);
  const tabs = loading ? [""] : data;
  const pages = createPagesArray(tabs);
  const location = useLocation();
  const navigate = useNavigate();
  let path = location.pathname.split("/");
  let pathName = path.length === 2 && decodeURIComponent(path[1]);
  const [name, setName] = useState(pathName);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElMore, setAnchorElMore] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleOpenMoreMenu = (event) => {
    setAnchorElMore(event.currentTarget);
  };
  const handleCloseMoreMenu = () => {
    setAnchorElMore(null);
  };
  const rearrangeArray = (array) => {
    const newArray = array.slice();
    newArray.sort((a, b) => {
      if (a.tag === "Home") return -1;
      if (b.tag === "Home") return 1;
      return a.tag.localeCompare(b.tag);
    });
    return newArray;
  };

  const rearrangedArray = rearrangeArray(pages);

  useEffect(() => {
    setName(pathName);
    sessionStorage.setItem("currentTab", location.pathname.slice(1));
  }, [location.pathname]);

  return (
    <ThemeProvider theme={theme}>
      <StyledAppBar
        position="static"
        sx={{ px: { xs: 2, md: 4 } }}
      >
        <Toolbar disableGutters sx={{ minHeight: { xs: 56, md: 64 } }}>
          {/* MySlides logo — primary brand */}
          <a
            href="/"
            style={{ display: "flex", alignItems: "center", textDecoration: "none", gap: 8 }}
          >
            <img
              src={process.env.PUBLIC_URL + "/myslides-logo.svg"}
              alt="MySlides"
              height={28}
            />
            <Typography
              sx={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600,
                color: "#1d1d1f",
                fontSize: "1.05rem",
                display: { xs: "none", sm: "block" },
              }}
            >
              MySlides
            </Typography>
          </a>

          <Box
            sx={{
              width: "1px",
              height: 20,
              backgroundColor: "#e0e0e0",
              mx: 2.5,
              display: { xs: "none", md: "block" },
            }}
          />

          {/* Mobile nav menu */}
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="navigation menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
            >
              <MenuIcon style={{ color: "#1d1d1f" }} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {rearrangedArray.map(
                (page) =>
                  (name === "home" || name === page.link || page.link === "home") && (
                    <Button
                      key={page.tag}
                      sx={{ my: 0, display: "block" }}
                    >
                      <NavButton
                        link={page.link}
                        tag={page.tag}
                      />
                    </Button>
                  )
              )}
            </Menu>
          </Box>

          {/* Desktop nav links with "More" overflow */}
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, alignItems: "center", gap: 0.5 }}>
            {(() => {
              const filtered = rearrangedArray.filter(
                (page) => name === "home" || name === page.link || page.link === "home"
              );
              const visible = filtered.slice(0, MAX_VISIBLE_LINKS);
              const overflow = filtered.slice(MAX_VISIBLE_LINKS);
              return (
                <>
                  {visible.map((page) => (
                    <NavButton key={page.tag} link={page.link} tag={page.tag} />
                  ))}
                  {overflow.length > 0 && (
                    <>
                      <IconButton
                        size="small"
                        onClick={handleOpenMoreMenu}
                        sx={{
                          ml: 0.5,
                          color: "#616161",
                          "&:hover": { color: "#1d1d1f" },
                        }}
                      >
                        <MoreHorizIcon sx={{ fontSize: 20 }} />
                      </IconButton>
                      <Menu
                        anchorEl={anchorElMore}
                        open={Boolean(anchorElMore)}
                        onClose={handleCloseMoreMenu}
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        transformOrigin={{ vertical: "top", horizontal: "left" }}
                      >
                        {overflow.map((page) => (
                          <MenuItem
                            key={page.tag}
                            onClick={() => {
                              navigate(`/${page.link}`);
                              handleCloseMoreMenu();
                            }}
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              fontSize: "0.875rem",
                              fontWeight: name === page.link ? 600 : 400,
                              color: name === page.link ? "#1d1d1f" : "rgb(100, 100, 100)",
                            }}
                          >
                            {page.tag}
                          </MenuItem>
                        ))}
                      </Menu>
                    </>
                  )}
                </>
              );
            })()}
          </Box>

        </Toolbar>
      </StyledAppBar>
    </ThemeProvider>
  );
};

export default Header;
